import BaseController from './basePlayerController';

export default class ControllerInfo extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eButtonsTypes = {
      EBT_INFO: 'info_button',
    };
    this._eEventTypes =  {
      INFO_CLICK: this.getEventName(this._eButtonsTypes.EBT_INFO),
    };
    this._eElementsTypes = {
      EET_INFO_BUTTON: this._eButtonsTypes.EBT_INFO,
    };

    this.init(container);
  }

  _getMarkup() {
    return `<button id=${this.interactiveElementsIds[this._eElementsTypes.EET_INFO_BUTTON]} data-role="info" data-color="primary">
            <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="44" cy="44" r="34.8333" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M44 56.8333V41.25" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M43.1858 29.604L43.1874 29.6024C43.5449 29.2458 44.1237 29.2463 44.4805 29.6036C44.8373 29.9609 44.8371 30.5397 44.4801 30.8967C44.1231 31.2538 43.5442 31.2539 43.187 30.8971C42.8297 30.5403 42.8292 29.9615 43.1858 29.604" stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg> 
          </button>`
  }
}
